// Types
import { AnyAction } from 'redux';
import { PersistenceLayerMessageAction, PersistenceLayerMessageType } from './persistenceLayerCommunicationTypes';

export const buildPersistenceLayerActionMessage = (action: AnyAction): PersistenceLayerMessageAction => ({
    type: PersistenceLayerMessageType.ACTION,
    payload: action,
});
